"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyRtValue = exports.rtValueToText = exports.copyTextStyleMarks = exports.textToRtValue = void 0;
const index_1 = require("../types/index");
const typeguards_1 = require("./typeguards");
const textToRtValue = (text, type = index_1.SlateElementType.elementDefault) => [{ type, children: [{ text: text }] }];
exports.textToRtValue = textToRtValue;
const slateElementTypes = Object.values(index_1.SlateElementType);
const slateElementMarks = Object.values(index_1.SlateElementMark);
const slateTextMarks = Object.values(index_1.SlateMark);
const copyTextStyleMarks = (node, sourceNode) => {
    if (typeof node !== typeof sourceNode) {
        return node;
    }
    if (Array.isArray(node)) {
        node.forEach((child, index) => {
            const sourceChild = Array.isArray(sourceNode) ? sourceNode[index] : undefined;
            return (0, exports.copyTextStyleMarks)(child, sourceChild);
        });
    }
    const nodeBlock = node;
    const sourceBlock = sourceNode;
    if (typeof nodeBlock !== 'object' ||
        (nodeBlock === null || nodeBlock === void 0 ? void 0 : nodeBlock.type) !== (sourceBlock === null || sourceBlock === void 0 ? void 0 : sourceBlock.type) ||
        !slateElementTypes.includes(nodeBlock.type)) {
        return node;
    }
    slateElementMarks.forEach((mark) => {
        if (typeof sourceBlock[mark] !== 'undefined') {
            nodeBlock[mark] = sourceBlock[mark];
        }
    });
    if (Array.isArray(nodeBlock.children) && Array.isArray(sourceBlock.children)) {
        nodeBlock.children.forEach((child, index) => {
            const childElement = child;
            const sourceChildElement = sourceBlock.children[index];
            if (typeof childElement !== 'object' || typeof childElement !== typeof sourceChildElement) {
                return;
            }
            slateTextMarks.forEach((mark) => {
                if (typeof sourceChildElement[mark] !== 'undefined') {
                    childElement[mark] = sourceChildElement[mark];
                }
            });
        });
        return nodeBlock;
    }
    return node;
};
exports.copyTextStyleMarks = copyTextStyleMarks;
const nodeToText = (node) => {
    if (!node) {
        return '';
    }
    if (typeof node === 'string') {
        return node;
    }
    if (Array.isArray(node)) {
        return node.map(nodeToText).join('');
    }
    if ((0, typeguards_1.isMention)(node)) {
        return ` ${node.name} `;
    }
    if ('children' in node) {
        return node.children.map(nodeToText).join('').trim();
    }
    if ('text' in node) {
        return node.text;
    }
    return '';
};
const rtValueToText = (value) => {
    if (Array.isArray(value)) {
        return value.map(nodeToText).join(' ').trim();
    }
    return nodeToText(value);
};
exports.rtValueToText = rtValueToText;
const isEmptyRtValue = (value) => {
    return (0, exports.rtValueToText)(value).trim() === '';
};
exports.isEmptyRtValue = isEmptyRtValue;
